<template>
    <div class="section">
        <div class="container">
            <div class="columns" style='min-height:800px;'>
                <div class="column is-6">
                    <div class="image is-2by2">
                        <img src="https://cdn.scotch.io/2842/b7yhhuUPSGO1fEkMHD6P_sticks.jpeg">
                    </div>
                </div>
                <div class="column is-5 is-offset-1">
                    <div class="title is-2">Bundle of Sticks</div>
                    <p class="title is-3 has-text-muted">$ 15</p>
                    <hr>
                    <br>
                    <p>This bundle of sticks provides an earthy fragrance and aesthetic natural appeal. Your bundle of sticks will come with a personalized note. The perfect natural gift for any time of year!</p>
                    <br>
                    <br>
                    <p class='level'>
                        <router-link to="/order" class="button is-large is-primary level-item has-text-centered">Buy Now</router-link>
                    </p>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>


// WEBPACK FOOTER //
// Product.vue?35339dee